module.exports = "/_next/static/images/award-Koran-Sindo-a44c843ee988cc06bfc0aac03f7d7e82.png";